export default {
	props: {
		overrideDepth: {
			type: Number,
			default: null
		}
	},
	computed: {
		depth() {
			// If the depth is set explicitly, then return it
			if (this.overrideDepth)
				return this.overrideDepth;
			// Otherwise, compute the heading depth from the component tree
			let depth = 1;
			let parent = this.$parent;
			while (parent) {
				if (parent.depth) {
					depth = parent.depth + 1;
					break;
				}
				parent = parent.$parent;
			}
			return depth;
		}
	}
};
